import moment from "moment";
interface PayFrequency {
    value: string;
    label: string;
}

const PAY_FREQUENCY = {
    select: { value: "", label: "Select" },
    weekly: { value: "Weekly", label: "Weekly" },
    biweekly: { value: "Bi-Weekly", label: "Bi-Weekly" },
    biMonthly: { value: "Bi-Monthly", label: "Bi-Monthly" },
    monthly: { value: "Monthly", label: "Monthly" },
    quarterly: { value: "Quarterly", label: "Quarterly" },
    yearly: { value: "Yearly", label: "Yearly" },
    oneTime: { value: "One-Time", label: "One-Time" },
    customPeriod: { value: "Custom Period", label: "Custom Period" },
} as const;

const DATE_FORMATS = ["MM/DD/YYYY", "M/D/YYYY", "YYYY-MM-DD"];

export interface CalculatePayFrequencyInput {
    startDate: string;
    endDate: string;
}

export const calculatePayFrequency = ({ startDate, endDate }: CalculatePayFrequencyInput): PayFrequency => {
    if (!startDate || !endDate) {
        return PAY_FREQUENCY.select;
    }

    const startDate_ = moment(startDate, DATE_FORMATS, true);
    const endDate_ = moment(endDate, DATE_FORMATS, true);

    if (!startDate_.isValid() || !endDate_.isValid()) {
        return PAY_FREQUENCY.select;
    }

    if (startDate_.isAfter(endDate_)) {
        return PAY_FREQUENCY.select;
    }

    const days = endDate_.diff(startDate_, "days") + 1;

    if (days === 1) return PAY_FREQUENCY.oneTime;

    if (startDate_.date() === 16 && endDate_.date() === endDate_.daysInMonth()) {
        return PAY_FREQUENCY.biMonthly;
    }

    if (days >= 15 && days <= 18) return PAY_FREQUENCY.biMonthly;
    if (days >= 2 && days <= 8) return PAY_FREQUENCY.weekly;
    if (days >= 9 && days <= 14) return PAY_FREQUENCY.biweekly;
    if (days >= 19 && days <= 32) return PAY_FREQUENCY.monthly;
    if (days >= 89 && days <= 92) return PAY_FREQUENCY.quarterly;
    if (days >= 364 && days <= 367) return PAY_FREQUENCY.yearly;

    return PAY_FREQUENCY.customPeriod;
};
